import { useAuth0 } from "@auth0/auth0-react";
import { LogOut } from "lucide-react";

const LogoutButton = () => {
  const { logout } = useAuth0();
  return (
    <button
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      className="btn btn-ghost btn-icon btn-sm"
      title="Sign out"
    >
      <LogOut size={16} />
    </button>
  );
};

export default LogoutButton;
